import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60dfbe8f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=60dfbe8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dfbe8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dfbe8f')) {
      api.createRecord('60dfbe8f', component.options)
    } else {
      api.reload('60dfbe8f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=60dfbe8f&scoped=true&", function () {
      api.rerender('60dfbe8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/draftCopy/index.vue"
export default component.exports